export const SUBMITTING_FORM = "SUBMITTING_FORM"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"


export const AUTH_VERIFICATION_SUCCESS = "AUTH_VERIFICATION_SUCCESS"
export const AUTH_VERIFICATION_FAIL = "AUTH_VERIFICATION_FAIL"

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_SUCCESS_FAIL"
export const CLEAR_CHANGE_PASSWORD = "CLEAR_CHANGE_PASSWORD"
export const CLEAR_AUTH_VERIFICATION = "CLEAR_AUTH_VERIFICATION"
export const REFRESH_TOKEN = "REFRESH_TOKEN "

export const LOGOUT = "LOGOUT"
export const ENJOY_BOARD_TOKEN = "ENJOY_BOARD_TOKEN"
export const ENJOY_BOARD_TOKEN_FAIL = "ENJOY_BOARD_TOKEN_FAIL"